module.exports = __webpack_public_path__ + "img/noData.1633c67e.png";